// extracted by mini-css-extract-plugin
export var button = "_ld-0";